import { CLEAN_IPB_INVOICE_LIST, CLEAN_IPB_INVOICE_LIST_ERROR } from '_models/redux/types';

export const cleanIPBInvoiceListAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_IPB_INVOICE_LIST,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_IPB_INVOICE_LIST_ERROR,
    });
  }
};
